"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BaseModal", {
  enumerable: true,
  get: function get() {
    return _baseModal["default"];
  }
});
exports["default"] = void 0;

var _modal = _interopRequireDefault(require("./modal"));

var _baseModal = _interopRequireDefault(require("./base-modal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _modal["default"];
exports["default"] = _default;